import { useMutation, UseMutationOptions, useQuery } from "@tanstack/react-query";
import { successMessage } from "../helpers/ErrorHandler";
import { ApiServiceErr, axiosApi, MutOptions } from "./apiService";

export const useGetSupplierDrawingRequests = (
  refetch: any,
  pageNumber: number,
  pageLimit: number,
  searchKey: string,
  filterProductIds: any[],
  sortBy: number
) =>
  useQuery(
    [
      "getSupplierDrawingRequests",
      pageNumber,
      pageLimit,
      searchKey,
      filterProductIds,
      sortBy,
      refetch
    ],
    async () => {
      const response = await axiosApi.post(`/supplier-drawing-request/received-request`, {
        pageNumber,
        pageSize: pageLimit,
        searchKey,
        productIds: filterProductIds,
        sortBy
      });
      return response.data;
    }
  );

export const useAcceptDrawingRequest = (opt?: UseMutationOptions) =>
  useMutation<string, ApiServiceErr, any>(async (arg: any) => {
    const response = await axiosApi.patch(
      `/supplier-drawing-request/accept-request/${arg.id}`,
      arg.data
    );
    successMessage(response.data);
    return response.data;
  }, opt);

export const useCompleteDrawingRequest = (opt?: UseMutationOptions) =>
  useMutation<string, ApiServiceErr, any>(async (ingredientId: string) => {
    const response = await axiosApi.post(
      `/firebase-notification/drawing-completed/${ingredientId}`,
      null
    );
    successMessage(response.data);
    return response.data;
  }, opt);

export const useDrawingRequestUpdate = (opt?: UseMutationOptions) =>
  useMutation<string, ApiServiceErr, any>(
    async ({ ingredientId, status }: { ingredientId: string; status: number }) => {
      const response = await axiosApi.patch(`/supplier-drawing-request/status/${ingredientId}`, {
        status
      });
      successMessage(response.data);
      return response.data;
    },
    opt
  );

export const useGetNotification = (
  isUserExist: any,
  refetch: any,
  skip: number,
  pageSize?: number | 10
) =>
  useQuery(
    ["getNotificationData", refetch, skip],
    async () => {
      const response = await axiosApi.get(`/firebase-notification`, {
        params: {
          skip,
          limit: pageSize
        }
      });
      return response.data;
    },
    {
      cacheTime: 10000,
      staleTime: 30000,
      refetchOnWindowFocus: true,
      enabled: !!isUserExist || refetch
    }
  );

export const useNotificationRead = (opt?: UseMutationOptions) =>
  useMutation<string, ApiServiceErr, any>(async (notificationId: string) => {
    const response = await axiosApi.put(`/firebase-notification/is-read/${notificationId}`, null);
    return response.data;
  }, opt);

export const useSupplierDrawingReminder = (opt?: MutOptions<void>) =>
  useMutation<any, ApiServiceErr, any>(async (data: any) => {
    const response = await axiosApi.patch(
      `/supplier-drawing-request/reminder/${data.supplierUserId}/${data.ingredientId}`
    );
    successMessage(response.data);
  }, opt);
